// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"22":"afb0f4f4","108":"4221e75f","783":"08f5bd20"}[chunkId] + ".js";
};